import { BlipChatKey } from '../models/BlipChatKey'

export class Misc {
  static getCurrentParentDomain() {
    const isSafari =
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1 &&
      navigator.userAgent.indexOf('Android') === -1

    return document.referrer
  }

  static hasParentWindow() {
    return window.location !== window.parent.location
  }

  static getCurrentDomain() {
    if (this.hasParentWindow()) {
      return this.getCurrentParentDomain()
    }

    return window.location.origin
  }

  static obfuscate(value) {
    if (!value) {
      return undefined
    }

    if (typeof value === 'object') {
      return btoa(JSON.stringify(value))
    }

    return btoa(value)
  }

  static deobfuscate(value) {
    if (!value) {
      return undefined
    }

    const data = atob(value)
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }

  static getQueryParam(param: string, decode?: boolean) {
    const query = window.location.search.substring(1)
    const queryParamsPair = query.split('&')
    const pair = queryParamsPair.find((e) => e.split('=')[0] === param) || ''

    return decode ? decodeURIComponent(pair.split('=')[1]) : pair.split('=')[1]
  }

  static decodeBlipKey(encodedkey: string): BlipChatKey {
    const [identifier, key] = this.deobfuscate(encodedkey).split(':')

    return { botIdentifier: identifier, botKey: key }
  }

  static async checkIfValidImage(imageSrc) {
    return await new Promise<boolean>( (resolve, reject) => {
      const img = new Image()
      img.onload = (e) => {
        resolve(true)
      }
      img.onerror = async () => {
        resolve(false)
      }
      img.src = imageSrc
    })
  }

  static async checkIfValidMedia(mediaSrc) {
    try {
      const media = new Audio(mediaSrc)
      media.play()
      media.pause()
      media.currentTime = 0
      media.volume = 1

      return true
    } catch (_) {
      return false
    }
  }

  static checkIfTypeIsAllowed(fileType) {
    const notAllowedMIMETypes = [
      'application/x-msdownload',
      'application/octet-stream',
      'application/vnd.microsoft.portable-executable',
      'application/x-msi',
    ]

    return !notAllowedMIMETypes.includes(fileType)
  }

  static async ValidFile(file) {
    if (file.size === 0) {
      return false
    }
    if (file.type.includes('image')) {
      const validImg = await Misc.checkIfValidImage(file.src)
      if (!validImg) {
        return false
      }
    }
    if (file.type.includes('audio')) {
      const validAudio = await Misc.checkIfValidMedia(file.src)
      if (!validAudio) {
        return false
      }
    }
    if (file.type.includes('video') && !file.type.includes('video/quicktime')) {
      const validVideo = await Misc.checkIfValidMedia(file.src)
      if (!validVideo) {
        return false
      }
    }

    return Misc.checkIfTypeIsAllowed(file.type)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/Misc.ts